<script lang="ts">
  export let size = 24;
 export let color = "black";
</script>

<svg width={size} height={size} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M17.0233 2H13.5833V8V8.75V13.75H22.8333V8.75V8V7.81C22.8333 4.17 20.6633 2 17.0233 2Z"
    fill={color}
    class={$$props.class}
  />
  <path
    d="M2.83331 10.25V15.25V15.75V16.19C2.83331 19.83 5.00331 22 8.64331 22H12.0833V15.75V15.25V10.25H2.83331Z"
    fill={color}
    class={$$props.class}
  />
  <path
    d="M12.0833 2V8.75H2.83331V7.81C2.83331 4.17 5.00331 2 8.64331 2H12.0833Z"
    fill={color}
    class={$$props.class}
  />
  <path
    d="M22.8333 15.25V16.19C22.8333 19.83 20.6633 22 17.0233 22H13.5833V15.25H22.8333Z"
    fill={color}
    class={$$props.class}
  />
</svg>
